module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/btn-download.424f0cef.png";